import type { CSSProperties } from "react";

/** CAIP-2 chain identifier (e.g. "eip155:612044") */
export type ChainId = `eip155:${number}`;

export enum ConnectorId {
  CROSSx = "crossx",
  MetaMask = "io.metamask",
  Binance = "com.binance.wallet",
}

export interface ConnectorMeta {
  name: string;
  iconUrl: string;
}

export const CONNECTOR_REGISTRY: Record<ConnectorId, ConnectorMeta> = {
  [ConnectorId.CROSSx]: {
    name: "CROSSx",
    iconUrl: "https://contents.crosstoken.io/wallet/token/images/tCROSS.svg",
  },
  [ConnectorId.MetaMask]: {
    name: "MetaMask",
    iconUrl: "https://upload.wikimedia.org/wikipedia/commons/3/36/MetaMask_Fox.svg",
  },
  [ConnectorId.Binance]: {
    name: "Binance Wallet",
    iconUrl: "https://public.bnbstatic.com/static/images/common/favicon.ico",
  },
};

export interface PreferredToken {
  chainId: ChainId;
  address: string;
}

export interface WalletInfoStyle extends CSSProperties {
  "--wi-primary"?: string;
  "--wi-secondary"?: string;
  "--wi-surface-bg"?: string;
  "--wi-surface-default"?: string;
  "--wi-surface-subtle"?: string;
  "--wi-border-default"?: string;
  "--wi-border-subtle"?: string;
  "--wi-texticon-primary"?: string;
  "--wi-texticon-secondary"?: string;
  "--wi-texticon-tertiary"?: string;
}

export interface TokenBalance {
  blockNumber: number;
  name: string;
  symbol: string;
  chainId: number;
  address: string;
  quantity: {
    decimals: number;
    numeric: string;
  };
  icon_url: string;
}

export interface TokenBalanceResponse {
  code: number;
  message: string;
  data: TokenBalance[];
}

export interface TokenStats {
  chain_id: number;
  address: string;
  price: string;
  percent_change_24h: string;
}

export interface TokenStatsResponse {
  code: number;
  message: string;
  data: TokenStats[];
}

export interface TokenInfo {
  chain_id: number;
  address: string;
  category: string;
}

export interface TokenInfoResponse {
  code: number;
  message: string;
  data: TokenInfo[];
}

export interface ForgeHolding {
  token: string;
  token_name: string;
  token_symbol: string;
  balance: string;
  current_price: string;
  value: string;
  average_cost_usd: number;
  current_value_usd: number;
  unrealized_pnl_usd: number;
  unrealized_pnl_cross: number;
  pnl_percentage: number;
}

export interface ForgeHoldingsResponse {
  success: boolean;
  data: {
    items: ForgeHolding[];
  };
}

export interface ForgeTokenDetail {
  address: string;
  name: string;
  symbol: string;
  image_url: string;
}

export interface ForgeTokenDetailResponse {
  success: boolean;
  data: {
    token: ForgeTokenDetail;
  };
}
